/*
==========================================
Custom JS for Wishlist page
==========================================
*/

// タブ切り替え
window.addEventListener('DOMContentLoaded', function(){
  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName('c-wishlist__tab');
  for(let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch, false);
  }

  // タブをクリックすると実行する関数
  function tabSwitch(){
    // タブのclassの値を変更
    document.querySelector('.c-wishlist__tab.is-active').classList.remove('is-active');
    this.classList.add('is-active');
    // コンテンツのclassの値を変更
    document.querySelector('.c-wishlist__panel.is-show').classList.remove('is-show');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('c-wishlist__panel')[index].classList.add('is-show');
  };
}, false);


const intervalId = setInterval(()=>{
  const wishListProductDetail = document.querySelector('.swym-wishlist-product-detail-container [aria-hidden="false"] .swym-more-details-btn')
  if(wishListProductDetail){
    //ドキュメントが読み込まれば場合の処理
    wishListProductDetail.click();
    clearInterval(intervalId);
   }
},500);